export default __webpack_public_path__ + "static/media/dp-net-core.12e2f801.png";